import { API_URL } from '../Config.js'

const apiUrl = API_URL

const getMicroserviciosList = (accessToken) => {
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  }

  const url = `${apiUrl}formularios/spGetServiciosInterfaz`

  return fetch(url, { headers })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => console.log('Error:', error))
}

const getMicroserviciosParamList = (accessToken, CodServicio, CodInterfaz) => {
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  }

  const url = `${apiUrl}formularios/spGetServiciosInterfazParam?CodServicio=${CodServicio}&CodInterfaz=${CodInterfaz}`

  return fetch(url, { headers })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => console.log('Error:', error))
}

const UpdateParam = (data, accessToken) => {
  const url = `${apiUrl}formularios/spUpdateInterfazParam`

  return (
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        return response.json()
      })
      //.then(data => {return data})
      .catch((error) => {})
  )
}

const UpdateStateEnviosInterfaces = (
  accessToken,
  spUpdateStateEnviosInterfacesRequest
) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  }

  const url = `${apiUrl}Formularios/spUpdateStateEnviosInterfaces`

  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(spUpdateStateEnviosInterfacesRequest),
    headers,
  }).then(async (response) => {
    const data = await response.json().catch(() => ({}))

    if (!response.ok) {
      const errorMessage =
        data.Message ||
        data.message ||
        response.statusText ||
        'Error en la petición'
      throw new Error(errorMessage)
    }

    return data
  })
}

const forceService = (accessToken, forceService_Request) => {
  const url = `${apiUrl}formularios/forceService`

  return (
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(forceService_Request),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        return response.json()
      })
      //.then(data => {return data})
      .catch((error) => {})
  )
}
export {
  getMicroserviciosList,
  getMicroserviciosParamList,
  UpdateParam,
  UpdateStateEnviosInterfaces,
  forceService,
}
